import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';

import { ApiConstants } from 'src/app/constants/api-constants';
import { HttpGuardService } from 'src/app/guards/http-guard.service';
import { DataService } from 'src/app/services/data.service';
import { ServicecallService } from 'src/app/services/servicecall.service';

@Injectable({
  providedIn: 'root'
})
export class WidgetsServiceService {
  private _thisWeekendDate: Date;
  private _nextWeekendDate: Date;
  private _startOfThisWeek: Date;
  private _startOfNextWeek: Date;
  private _startOfToday: Date;
  private _endOfToday: Date;

  constructor(private httpGuard: HttpGuardService, private serviceCall: ServicecallService, private _dataSer: DataService, private datePipe: DatePipe) { }
  alertStatistics(reqData) {
    const payload = {
      from: reqData.from,
      to: reqData.to,
      siteId: reqData.siteId
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.alertStatistics, payload, false);
  }
  fleetCategoryCount(reqData) {
    const payload = {
      from: reqData.from,
      to: reqData.to,
      siteId: reqData.siteId
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.fleetCategoryCount, payload, false);
  }
  entityInfo(reqData) {
    const payload = {
      siteId: reqData.siteId,
      from: reqData.from,
      to: reqData.to
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.entityInfo, payload, false);
  }
  activeEntities(reqData) {
    const payload = {
      siteId: sessionStorage.getItem('siteId') ?
        JSON.parse(sessionStorage.getItem('siteId') || '{}') : null,
      from: reqData.from ? reqData.from : null,
      to: reqData.to ? reqData.to : null
    }
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.activeEntities, payload, false);
  }
  vehicleStatistics(reqData) {
    const payload = {
      siteId: reqData.siteId
    }
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.vehicleStatistics, payload, false);
  }
  scoreBasedEntities() {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.scoreBasedEntities, {}, false);
  }
  monotainerStagingCount() {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.monotainerStagingCount, {}, false);
  }

  monotainerCurrentCount() {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.monotainerCurrentCount, {}, false);
  }

  monotainerTotalCount() {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.monotainerTotalCount, {}, false);
  }

  activeEntityDetails(payload: any, page?: any, loaderNeeded: boolean = false) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', `${ApiConstants.URL.activeEntityDetails}/${page}`, payload, loaderNeeded);
  }

  getAlerts(payload: any, page?: any, isLoaderNeeded: boolean = true) {
    if (page)
      return this.httpGuard.httpReq('post', 'API_ENDPOINT', `${ApiConstants.URL.alertList}/${page}`, payload, false);
    else {
      return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.alertList, payload, false, 'events', 'widget');
    }
  }

  getDTCList(payload: any, isLoaderNeeded: boolean = true) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.getLatestDTC, payload, false, 'events', 'widget');
  }

  attributeAlertsCount(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.attributeAlertsCount, payload, false);
  }

  devicesCount(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.devicesCount, payload, false);
  }

  entityCount(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.entityCount, payload, false);
  }

  getMonotainerCountDetails(type: any = 'counts', by: any = 'lane') {
    const siteId = sessionStorage.getItem('siteId') ?
      JSON.parse(sessionStorage.getItem('siteId') || '{}') : null;
    let params: any;
    if (type === 'counts') {
      params = siteId ? '?category=monotainer&type=' + type + '&siteId=' + siteId :
        '?category=monotainer&type=' + type;
    } else {
      params = siteId ? '?category=monotainer&type=' + type + '&by=' + by + '&siteId=' + siteId :
        '?category=monotainer&type=' + type + '&by=' + by;
    }
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.getMonotainerCountDetails, params, false);
  }

  replacementCount(classType: string) {
    const params = '?class=' + classType;
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.replacementCount, params, false);
  }

  fetchLeastGraph(classType: string) {
    const params = '?class=' + classType + '&size=' + this.serviceCall.getConfiguration('trlThresholds')?.leastRulCountThreshold;
    return this.httpGuard.httpReq('get', 'API_ENDPOINT', ApiConstants.URL.leastGraph, params, false);
  }

  getTotalElectricConsumption(payloadData: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.attributeAggregation, payloadData, false);
  }

  entityUsageStatistics(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.entityUsageStatistics, payload, false);
  }

  entityCategoryState(payload: any) {
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', ApiConstants.URL.entityCategoryState, payload, false);
  }

  getEntityListByType(entityType: number, view: 'table' | 'count') {
    const payload = {
      status: true,
      page: 1,
      filter: null,
      siteId: this.serviceCall.getSiteId(),
      type: entityType,
      category: null,
      searchKey: undefined
    };
    return this.httpGuard.httpReq('post', 'API_ENDPOINT', `${ApiConstants.URL.entitiesList}/${payload.page}`, payload, false).subscribe((result: any) => {
      const masterEntityData = result['response']?.['data'];
      if (result['status'] && masterEntityData?.length) {
        if (view === 'count') {
          let todayCount = 0;
          let thisWeekCount = 0;
          let nextWeekCount = 0;
          masterEntityData?.forEach((item: any) => {
            const service = item?.certificateDetails?.service;
            if ((new Date(service) >= this._startOfToday) && (new Date(service) <= this._endOfToday)) {
              todayCount = todayCount + 1;
            } else if ((new Date(service) >= this._startOfThisWeek) && (new Date(service) <= this._thisWeekendDate)) {
              thisWeekCount = thisWeekCount + 1;
            } else if ((new Date(service) >= this._startOfNextWeek) && (new Date(service) <= this._nextWeekendDate)) {
              nextWeekCount = nextWeekCount + 1;
            }
          });
          thisWeekCount += todayCount;
          this._dataSer.broadcast('serviceReminderCountUpdated', { todayCount: todayCount, thisWeekCount: thisWeekCount, nextWeekCount: nextWeekCount });
        } else {
          let tableData = { today: [], thisWeek: [], nextWeek: [] };
          masterEntityData?.forEach((item: any) => {
            const service = item?.certificateDetails?.service;
            const site = item.sites?.length ? item.sites[0]?.name : '--';
            if ((new Date(service) >= this._startOfToday) && (new Date(service) <= this._endOfToday)) {
              tableData.today.push({ asset: item?.name, location: site, dueOn: this.datePipe.transform(new Date(service), 'MMMM d, y') });
              tableData.thisWeek.push({ asset: item?.name, location: site, dueOn: this.datePipe.transform(new Date(service), 'MMMM d, y') });
            } else if ((new Date(service) >= this._startOfThisWeek) && (new Date(service) <= this._thisWeekendDate)) {
              tableData.thisWeek.push({ asset: item?.name, location: site, dueOn: this.datePipe.transform(new Date(service), 'MMMM d, y') });
            } else if ((new Date(service) >= this._startOfNextWeek) && (new Date(service) <= this._nextWeekendDate)) {
              tableData.nextWeek.push({ asset: item?.name, location: site, dueOn: this.datePipe.transform(new Date(service), 'MMMM d, y') });
            }
          });
          this._dataSer.broadcast('serviceDueTableUpdated', tableData);
        }
      } else {
        if (view === 'count') {
          this._dataSer.broadcast('serviceReminderCountUpdated', { todayCount: 0, thisWeekCount: 0, nextWeekCount: 0 });
        } else {
          this._dataSer.broadcast('serviceDueTableUpdated', { today: [], thisWeek: [], nextWeek: [] });
        }
      }
    });
  }

  calculateWeekendDates() {
    const today = new Date();
    const currentDayOfWeek = today.getDay();

    this._startOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0); // Start of today
    this._endOfToday = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59); // End of today

    // Calculate this weekend's date
    const daysUntilSaturday = 6 - currentDayOfWeek;
    const thisSaturday = new Date(today.getFullYear(), today.getMonth(), today.getDate() + daysUntilSaturday);
    this._thisWeekendDate = thisSaturday;

    // Calculate next weekend's date
    const daysUntilNextSaturday = daysUntilSaturday + 7;
    const nextSaturday = new Date(today.getFullYear(), today.getMonth(), today.getDate() + daysUntilNextSaturday);
    this._nextWeekendDate = nextSaturday;

    const nextWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 7);
    // Calculate start of this week
    this._startOfThisWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay());
    // Calculate start of this next week
    this._startOfNextWeek = new Date(nextWeek.getFullYear(), nextWeek.getMonth(), nextWeek.getDate() - nextWeek.getDay());

  }

}
